(function(){
  document.querySelectorAll('[data-sg]').forEach(function(root){
    if(root.dataset.sgReady) return; root.dataset.sgReady='1';
    var q=function(s){return root.querySelector(s)},qa=function(s){return [].slice.call(root.querySelectorAll(s))};
    var track=q('[data-sg-track]'),slides=qa('[data-sg-slide]'),thumbs=qa('[data-sg-thumb]'),tiers=qa('[data-sg-tier]'),
        idInput=q('[data-sg-id]'),nameEl=q('[data-sg-name]'),countEl=q('[data-sg-count]'),cta=q('[data-sg-cta]'),buyNow=q('[data-sg-buynow]'),
        form=cta.form,setEl=q('[data-sg-set]'),slotsEl=q('[data-sg-slots]'),setLabel=q('[data-sg-set-label]'),note=q('[data-sg-note]'),sp=q('[data-sg-sp]'),
        reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches,active=-1,ticking=false,picks=[],slot=0,busy=false,
        fmtStr=root.dataset.moneyFormat||'$[[amount]]',nf=null;
    try{nf=new Intl.NumberFormat(root.dataset.locale||undefined,{style:'currency',currency:root.dataset.currency})}catch(e){nf=null}
    if(!track||!slides.length) return;
    function pad(n){return (n<10?'0':'')+n}
    function money(c){
      if(nf)return nf.format(c/100);
      var f=(c/100).toFixed(2),n=String(Math.round(c/100));
      return fmtStr.replace(/[\{\[]{2}\s*(\w+)\s*[\}\]]{2}/,function(m,k){
        if(k==='amount_no_decimals')return n;
        if(k==='amount_with_comma_separator')return f.replace('.',',');
        return f;
      });
    }
    function tier(){return tiers.filter(function(t){return t.checked})[0]||tiers[0]}
    function qty(){return parseInt(tier().dataset.qty,10)||1}
    function pct(t){return parseFloat((t||tier()).dataset.pct)||0}
    function cents(i){return parseInt(slides[i].dataset.cents,10)||0}
    function render(){
      var n=qty(),s=slides[active],sum=0,ok=true;
      picks.forEach(function(p){sum+=cents(p);if(slides[p].dataset.available!=='true')ok=false});
      var total=Math.round(sum*(1-pct()/100))+(sp&&sp.checked?(parseInt(sp.dataset.cents,10)||0):0);
      tiers.forEach(function(t){
        var k=parseInt(t.dataset.qty,10),full=cents(active)*k,box=t.parentNode;
        box.querySelector('[data-sg-tier-price]').textContent=money(Math.round(full*(1-pct(t)/100)));
        box.querySelector('[data-sg-tier-was]').textContent=pct(t)>0?money(full):'';
      });
      setEl.hidden=n<2;
      if(n>1){
        setLabel.textContent=setLabel.dataset.text.replace('[n]',slot+1).replace('[total]',n);
        slotsEl.innerHTML='';
        picks.forEach(function(p,k){
          var li=document.createElement('li'),b=document.createElement('button'),sp=document.createElement('span'),src=slides[p].dataset.thumb,im=document.createElement(src?'img':'i');
          b.type='button';b.className='sg__slot';b.setAttribute('aria-pressed',k===slot?'true':'false');
          if(src){im.src=src;im.alt=''}
          sp.textContent=(k+1)+'. '+slides[p].dataset.name;b.appendChild(im);b.appendChild(sp);
          b.addEventListener('click',function(){slot=k;if(picks[k]===active){render()}else{go(picks[k])}});
          li.appendChild(b);slotsEl.appendChild(li);
        });
      }
      idInput.value=slides[picks[0]].dataset.variantId; nameEl.textContent=s.dataset.name; countEl.textContent=pad(active+1)+' / '+pad(slides.length);
      cta.disabled=buyNow.disabled=!ok||busy; cta.textContent=ok?(cta.dataset.label+' — '+money(total)):cta.dataset.soldOut;
    }
    function setActive(i){
      if(i===active) return; active=i; picks[slot]=i;
      slides.forEach(function(el,k){el.classList.toggle('is-active',k===i)});
      thumbs.forEach(function(el,k){el.setAttribute('aria-current',k===i?'true':'false')});
      var t=thumbs[i],list=t&&t.parentNode.parentNode;
      if(list&&list.scrollTo)list.scrollTo({left:t.parentNode.offsetLeft-list.offsetLeft-list.clientWidth/2+t.clientWidth/2,behavior:reduce?'auto':'smooth'});
      try{var u=new URL(window.location.href);u.searchParams.set('variant',slides[i].dataset.variantId);history.replaceState(null,'',u)}catch(e){}
      render();
    }
    function nearest(){var c=track.scrollLeft+track.clientWidth/2,b=0,d=Infinity;slides.forEach(function(el,k){var x=Math.abs(el.offsetLeft+el.offsetWidth/2-c);if(x<d){d=x;b=k}});return b}
    function go(i,instant){i=(i+slides.length)%slides.length;var el=slides[i];track.scrollTo({left:el.offsetLeft+el.offsetWidth/2-track.clientWidth/2,behavior:(instant||reduce)?'auto':'smooth'})}
    track.addEventListener('scroll',function(){if(ticking)return;ticking=true;requestAnimationFrame(function(){ticking=false;setActive(nearest())})},{passive:true});
    q('[data-sg-prev]').addEventListener('click',function(){go(active-1)});
    q('[data-sg-next]').addEventListener('click',function(){go(active+1)});
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){go(k)})});
    track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(active+1)}if(e.key==='ArrowLeft'){e.preventDefault();go(active-1)}});
    tiers.forEach(function(t){t.addEventListener('change',function(){
      var n=qty();
      if(picks.length>n){picks.length=n;if(slot>n-1){slot=n-1;if(picks[slot]!==active){go(picks[slot]);return}}}
      else if(picks.length<n){slot=picks.length;while(picks.length<n)picks.push(active)}
      render();
    })});
    if(sp)sp.addEventListener('change',render);
    function send(dest){
      if(busy)return;busy=true;note.classList.remove('is-error');render();
      var map={},items=[];
      picks.forEach(function(p){var id=slides[p].dataset.variantId;map[id]=(map[id]||0)+1});
      Object.keys(map).forEach(function(id){items.push({id:Number(id),quantity:map[id]})});
      if(sp&&sp.checked)items.push({id:Number(sp.dataset.id),quantity:1});
      var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){if(!r.ok)throw new Error(r.status);window.location.href=base+dest})
        .catch(function(){busy=false;note.textContent=note.dataset.error;note.classList.add('is-error');render()});
    }
    form.addEventListener('submit',function(e){e.preventDefault();send('cart')});
    buyNow.addEventListener('click',function(){send('checkout')});
    var down=false,sx=0,sl=0,moved=false;
    track.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;sx=e.clientX;sl=track.scrollLeft});
    window.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-sx;if(Math.abs(dx)>4){moved=true;track.classList.add('is-dragging')}if(moved)track.scrollLeft=sl-dx});
    window.addEventListener('pointerup',function(){if(!down)return;down=false;if(moved){var i=nearest();track.classList.remove('is-dragging');go(i)}});
    var start=Math.max(0,slides.findIndex(function(s){return s.dataset.initial==='true'}));
    picks=[start];go(start,true);setActive(start);
    window.addEventListener('resize',function(){go(active,true)});
  });
})();
